<template>
	<div class="d-flex flex-row justify-content-center align-content-center px-0">
		<botao-tooltip
			id="botao-responder"
			icone="mdi-forum-outline"
			v-if="hasAuthority"
			v-az-auth="permissoes.ataOcorrenciaRespostaCriar"
			cor="grey"
			texto="Responder Ocorrência"
			@click="$emit('responder', item)"
		></botao-tooltip>
		<template v-if="podeMostrarBotaoExcluirEBotaoEditar(item)">
			<botao-tooltip
				id="botao-editar"
				icone="mdi-pencil"
				v-az-auth="permissoes.ataOcorrenciaEditar"
				cor="grey"
				texto="Editar Ocorrência"
				@click="$emit('editar', item)"
			></botao-tooltip>
			<botao-tooltip
				id="botao-excluir"
				icone="mdi-delete"
				v-az-auth="permissoes.ataOcorrenciaExcluir"
				cor="grey"
				texto="Excluir"
				@click="$emit('excluir', item.id)"
			></botao-tooltip>
		</template>
		<botao-tooltip
			v-if="item.quantidadeRespostas > 0"
			id="botao-visualizar"
			icone="mdi-eye-outline"
			v-az-auth="permissoes.ataOcorrenciaRespostaListar"
			cor="grey"
			texto="Visualizar Ocorrência"
			@click="$emit('visualizar', item)"
		></botao-tooltip>
	</div>
</template>

<script>
import permissoesMixin from '@/views/mixins/permissoes-mixin'
import { opcaoSimNao } from '@/core/constants'

export default {
	name: 'listagem-ocorrencia-acoes',
	mixins: [permissoesMixin],
	props: {
		item: {
			type: Object,
			required: true,
		},
		hasAuthority: {
			type: Boolean,
		},
	},
	methods: {
		podeMostrarBotaoExcluirEBotaoEditar(item) {
			return item.habilitaEdicao === opcaoSimNao.SIM.value && item.quantidadeRespostas === 0 && this.hasAuthority
		},
	},
}
</script>

<style scoped lang="stylus">
.justify-content-center
	justify-content center
</style>
